import styled from "styled-components"
import { getCssSizeValue, isStringEmpty } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"
import Image from "@/components/common/Image"
import { IMAGE_FALLBACK } from "@/constants"
import Video from "@/components/common/Video"
import React, { useMemo, useState } from "react"
import useDevice from "@/hooks/useDevice"
import VideoControls from "@/components/Banners/SubPage/Components/VideoControls"
import GridContainer from "@/components/common/GridContainer"
import BannerCard from "@/components/Banners/SubPage/Components/BannerCard"
import AssetWrapper from "@/components/Banners/SubPage/Components/AssetWrapper"

const Wrapper = styled.section`
	overflow: hidden;
	position: relative;
	height: 100svh;
	width: 100%;
	display: flex;
	align-items: flex-end;
	padding-bottom: ${getCssSizeValue(20, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding-bottom: ${getCssSizeValue(48)};
	}
`

const CommonVideo = styled(Video)`
	overflow: hidden;
	position: relative;
	width: 100%;
	height: 100%;
`

const StyledGridContainer = styled(GridContainer)`
	pointer-events: none;
	position: relative;
	z-index: 3;
	align-items: end;
	transition: all var(--rgr-duration) var(--ease);

	&.hide {
		opacity: 0;
		pointer-events: none;
	}
`

export default function ImageWithButtonToStartBackgroundVideo({ data }) {
	const assetVideoUrl = data?.video?.url || ""
	const externalVideoUrl = data?.externalVideo?.url || ""
	const videoSrc = assetVideoUrl !== "" ? assetVideoUrl : externalVideoUrl

	const [isVideoPlaying, setIsPlaying] = useState(false)
	const orientation = useDevice("orientation")

	const image = useMemo(() => {
		const image = orientation === "landscape" ? data?.image : data?.imageVertical
		return image || data?.image || IMAGE_FALLBACK //if vertical image is not set use default one or fallback
	}, [orientation, data])

	const handleToggleVideo = () => {
		setIsPlaying((prev) => !prev)
	}

	return (
		<Wrapper>
			{!isStringEmpty(videoSrc) && <VideoControls handleToggleVideo={handleToggleVideo} isVideoPlaying={isVideoPlaying} />}
			<AssetWrapper className={`${isVideoPlaying ? "hide" : "show"} above`}>
				<Image
					src={image.url}
					alt={image.alt}
					priority
					placeholder={image.blurUpThumb}
					focalPoint={image.focalPoint}
					sizes="100vw"
				/>
			</AssetWrapper>

			<AssetWrapper>
				<CommonVideo src={videoSrc} playing={isVideoPlaying} onClick={handleToggleVideo} resetOnPause={false} muted={false} />
			</AssetWrapper>

			<StyledGridContainer className={isVideoPlaying ? "hide" : ""}>
				<BannerCard data={data} />
			</StyledGridContainer>
		</Wrapper>
	)
}
